import { IntakeFormsCard } from './intakeFormsCard'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const IntakeFormsCards = ({ intakeFormsList, chartsId, userTimeZone, patientChartsSearchRow }) =>
  intakeFormsList.map(
    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    ({ IntakeFormId, QuestionnaireSessionId, Name, CompleteDateTime, VisitTypeName, isQuestionnaire }) => (
      <IntakeFormsCard
        key={isQuestionnaire ? QuestionnaireSessionId : IntakeFormId}
        id={IntakeFormId}
        sessionId={QuestionnaireSessionId}
        isQuestionnaire={isQuestionnaire}
        chartsId={chartsId}
        name={Name}
        completeDate={CompleteDateTime}
        visitType={VisitTypeName}
        userTimeZone={userTimeZone}
        patientChartsSearchRow={patientChartsSearchRow}
      />
    ),
  )
